import React, {useState} from "react";
import styled from "styled-components";
import {Primitive} from "../../../../../Types";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
    name: string
}

export default function RawEditStringTextarea({value, onChange, name}: PropsI) {

    let [newValue, setNewValue] = useState<string>(value === null ? '' : value)
    const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNewValue(e.currentTarget.value);
    };



    return <TextArea name={"edit-" + name} id={"edit-" + name} cols={30}
                     value={newValue}
                     onChange={onChangeHandler}
                     onBlur={() => onChange(newValue)}
                     rows={4}></TextArea>

}


const TextArea=  styled.textarea`
    text-indent: 2px;
`
